// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"154":"def5d5b2","264":"2abb26d4","382":"b3b4e9c7","422":"4aa70907","512":"748d400a","671":"9feeb0e1","796":"ea14a162","809":"11bc1e92","925":"d960c311","979":"5388b403"}[chunkId] + ".chunk.js";
};